import { render, staticRenderFns } from "./outer-rank-list.vue?vue&type=template&id=009b7e08&scoped=true"
import script from "./outer-rank-list.vue?vue&type=script&lang=ts"
export * from "./outer-rank-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b7e08",
  null
  
)

export default component.exports